<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Mi Cuenta Bancaria</h4>
        <div class="text-center">
            <div class="figure-profile radius-none border-0 my-4">
                <figure class="radius-none">
                    <img :src="'/img/bank.png'" alt="Cuenta Bancaria" title="Cuenta Bancaria">
                </figure>
            </div>
        </div>

        <b-form id="formAccount" @submit.stop.prevent="submit">
            <b-row class="justify-content-center">
                <b-col cols="12" md="10" align-self="start">
                    <b-form-group :label="labels.bank+':'" label-class="text-center">
                        <b-form-select
                            name="bank"
                            :options="banks"
                            :value="form.bank"
                            v-model="form.bank"
                            v-validate="'required:true'"
                            :state="validateState('bank')"
                            :data-vv-as="(labels.bank).toLowerCase()"
                            :disabled="loading"
                            aria-describedby="bank-live-feedback"
                            class="form-control"
                            value-field="code"
                            text-field="name"
                        ></b-form-select>
                        <b-form-invalid-feedback id="bank-live-feedback">{{ veeErrors.first('bank') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.tc+':'" label-class="text-center">
                        <b-form-select
                            name="tc"
                            :options="categories"
                            :value="form.tc"
                            v-model="form.tc"
                            v-validate="'required:true'"
                            :state="validateState('tc')"
                            :data-vv-as="(labels.tc).toLowerCase()"
                            :disabled="loading"
                            aria-describedby="tc-live-feedback"
                            class="form-control"
                        ></b-form-select>
                        <b-form-invalid-feedback id="tc-live-feedback">{{ veeErrors.first('tc') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.nc+':'" label-class="text-center">
                        <b-form-input
                            name="nc"
                            type="number"
                            inputmode="numeric"
                            v-model="form.nc"
                            v-validate="'required:true'"
                            :state="validateState('nc')"
                            :data-vv-as="(labels.nc).toLowerCase()"
                            :disabled="loading"
                            aria-describedby="nc-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="nc-live-feedback">{{ veeErrors.first('nc') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="justify-content-center">
                <b-col cols="12" md="10" class="my-5 text-center">
                    <b-button type="submit" variant="default" size="lg" pill class="shadow px-5"
                              form="formAccount" :disabled="loading">
                        <b-spinner small type="grow" v-if="loading"></b-spinner>
                        <b-icon icon="patch-check-fill" aria-hidden="true" v-else></b-icon>
                        &nbsp;&nbsp;<span>{{ loading ? labels.load : labels.save }}</span>
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import axios from "axios";

export default {
    name: "Account",
    props: [ 'user' ],
    data: () => ({
        labels: {
            bank: 'Entidad Bancaria',
            tc: 'Tipo de Cuenta',
            nc: 'Número de Cuenta',

            load: 'Actualizando...',
            save: 'Actualizar'
        },
        form: {
            bank: null,
            tc: null,
            nc: null
        },
        banks: [],
        categories: [

        ],
        loading: false
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'infopage');
        this.getData();
    },
    watch: {
        'user.country'() {
            this.getBanks(this.user.country)
        }
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/customer/account').then((res) => {
                if (res.data.status === 'success') {
                    this.form = res.data.account;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
                this.getBanks(this.user.country)
            });
        },
        getBanks(v) {
            axios.get('/api/customer/_All_/' + v + '/banks').then((res) => {
                this.banks = res.data.banks;
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            });
            this.categories = [];
            (this.categories).push({ value: 'Ahorros', text: 'Cuenta de Ahorros' });
            (this.categories).push({ value: 'Corriente', text: 'Cuenta Corriente' });
            if (v === 'CL') {
                (this.categories).push({ value: 'RUT', text: 'Cuenta RUT' });
                (this.categories).push({ value: 'Vista', text: 'Cuenta Vista' });
                (this.categories).push({ value: 'Chequera', text: 'Chequera Electrónica' });
                (this.categories).push({ value: 'Dolar', text: 'Cuenta Dolar' });
            }
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        submit() {
            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                this.loading = true;

                axios.post('/api/customer/account/update', this.form).then(res => {
                    this.$root.$bvToast.toast(res.data.msg, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: res.data.status,
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                    this.$validator.reset();
                }).catch(err => {
                    this.$root.$bvToast.toast(err.response.data.errors, {
                        title: 'Notificación',
                        headerClass: 'd-none',
                        variant: 'error',
                        toaster: 'b-toaster-top-right',
                        autoHideDelay: 5000,
                        solid: true,
                        appendToast: true
                    });
                }).then(() => {
                    this.loading = false;
                });
            });
        }
    }
}
</script>

<style scoped>

</style>
